// extracted by mini-css-extract-plugin
export default {"container":"CardTag_container__Tan6i","icon":"CardTag_icon__X-o1P"};